import { getRandomString } from './string';

// eslint-disable-next-line import/prefer-default-export
export function getPassportImageFilename(guest) {
  const passportNumberB64 = btoa(`${guest.firstName}_${guest.surname}`);
  const typeAbbr = 'Pa';
  const randomText = getRandomString(10);
  return `${passportNumberB64}${typeAbbr}${randomText}`;
}
